import PlaceTypeSelect from "@/components/form/place-type-select";
import {
  makePickerField,
  type PickerFieldProps,
} from "@/fields/_internal/make-picker-field";

type PlaceTypeFieldExtraProps = {
  placeholder?: string;
  align?: "start" | "center" | "end";
};

/** **Value is a `PlaceType` string**; `""` = nothing selected. */
export type PlaceTypeFieldProps = PickerFieldProps<
  string,
  PlaceTypeFieldExtraProps
>;

export const PlaceTypeField = makePickerField<string, PlaceTypeFieldExtraProps>(
  {
    name: "PlaceTypeField",
    control: PlaceTypeSelect,
    popout: true,
    controlProps: (props) => ({
      placeholder: props.placeholder,
      align: props.align,
    }),
  },
);
